<template>
    <div id="app">
        <pie-chart :data="chartData" :options="chartOptions" class="styled"></pie-chart>
    </div>
</template>

<script>
    import PieChart from "./PieChart.js";

    export default {
        name: "RegionChart",
        props: ['getWineRegionNamesArr', 'getInvestmentPercentRegionArr'],
        components: {
            PieChart,
        },
        data() {
            return {
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    style: {
                        width: 150,
                        height: 150,
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return data.labels[tooltipItem.index] + ' - ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%'
                            }
                        }
                    }
                },
                chartData: {
                    labels: this.getWineRegionNamesArr,
                    datasets: [
                        {
                            backgroundColor: ['#E2C477', '#AC955B', '#75663E', '#E9D297', '#EFDFB6', '#EFDFB6'],
                            data: this.getInvestmentPercentRegionArr
                        }
                    ]
                },
            };
        }
    };
</script>

<style scoped>
    .styled {
        width: 150px;
        height: 150px;
        margin: 0 auto;
    }

    @media all and (max-width: 1440px) {
        .styled {
            width: 120px;
            height: 120px;
            margin: 0;
        }
    }

    @media all and (max-width: 1280px) {
        .styled {
            width: 100px;
            height: 100px;
        }
    }
</style>
